import React, { Component } from 'react'
import StyleSheet from 'styles'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography'
import FlexDataView from 'components/FlexDataView'
import { Authorization } from 'utils/AuthorizationUtils'
import { DealSheet, Investor, Rates, AllocationSize, Transactions, Invest, Commissions } from 'components/allocation'
import {Markdown, TextAgreement, InputDialog} from 'components'
import { DialogHandler } from 'utils'
import moment from 'moment'
import 'utils/locale'
import {FormattedMessage} from 'react-intl'

export class AllocationView extends Component {
  static propTypes = {
    allocation: PropTypes.object,
    expanded: PropTypes.bool,
    onExpand: PropTypes.func,
    tncs: PropTypes.string,
    onRequestTncs: PropTypes.func,
    onInvestTncsAgreed: PropTypes.func,
    onRefund: PropTypes.func,
  }

  state = {pendingInvest: false}
  tncsHandler = new DialogHandler(this)
  destinationAddressHandler = new DialogHandler(this, 'destinationAddressDialog')

  get allocationIsCurrent() {
    const {startDate, endDate, saftComplete} = this.props.allocation
    return saftComplete && moment(startDate) <= moment(Date.now()) && moment(endDate) > moment(Date.now())
  }

  get dealSheetIsActive() {
    return this.props.allocation.dealSheet.status === 'active'
  }

  handleInvest = async() => {
    const { allocation, onInvestTncsAgreed} = this.props

    let agreed = true
    if (allocation.hasTermsAndConditions) {
      await this.props.onRequestTncs(allocation)
      agreed = await this.tncsHandler.show()
    }

    let destinationAddress
    if (allocation.dealSheet.typeOfIssuance === 'product') {
      destinationAddress = await this.destinationAddressHandler.show()
      if (!destinationAddress) {
        return
      }
    }

    if (agreed) {
      this.setState({pendingInvest: true})
      try {
        await onInvestTncsAgreed(allocation, destinationAddress)
      }
      finally {
        this.setState({pendingInvest: false})
      }
    }
  }

  render = () => {
    const { allocation, expanded, onExpand, tncs, onRefund, onCreateTransaction, onDeleteTransaction } = this.props
    const { pendingInvest } = this.state
    const isEquity = this.props.allocation.dealSheet.typeOfIssuance === 'equity'

    return (
      <div id={`allocation${allocation.id}`} className={styles.wrapper}>
        <div className={styles.allocationHeader}>
          <Typography variant="h5">
            <FormattedMessage id="allocations.list.item.title" values={{date: moment(allocation.startDate)}} />
          </Typography>
          <IconButton aria-label="expand-less" onClick={onExpand}>
            {expanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
          </IconButton>
        </div>
        <Collapse in={expanded} className={styles.allocationCollapse}>
          <FlexDataView>
            {!Authorization.investor &&
              <Investor allocation={allocation}/>
            }
            <DealSheet allocation={allocation}/>
            {Authorization.investor &&
              <Invest allocation={allocation} disabled={!this.allocationIsCurrent || !this.dealSheetIsActive} onInvest={this.handleInvest} pendingInvest={pendingInvest}/>
            }
            {!isEquity && <Rates allocation={allocation}/> }
            <AllocationSize allocation={allocation} className={styles.large}/>
            {Authorization.admin &&
              <Commissions allocation={allocation}/>
            }
            <Transactions allocation={allocation} className={styles.xlarge}
                          onRefund={onRefund} onCreate={onCreateTransaction} onDelete={onDeleteTransaction}/>
          </FlexDataView>
        </Collapse>
        <TextAgreement {...this.tncsHandler.props} title='Terms and Conditions'>
          <Markdown mdtext={tncs} />
        </TextAgreement>
        <InputDialog {...this.destinationAddressHandler.props} explanation="Enter your destination ERC20 Address" label="ERC20 Address" valueRequired />
      </div>
    )
  }
}

export default AllocationView

export const styles = StyleSheet({
  wrapper: {
    width: '100%'
  },
  allocationHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 15,
    '& h5': {
      marginBottom: 0
    }
  },
  contactUs: {
    padding: 15
  },
  allocationCollapse: {
    overflowY: 'visible',
    '@media(max-width: 600px)': {
      marginLeft: -20,
      marginRight: -20,
    },
    '& > :last-child': {
      marginBottom: 36,
    }
  }
})